import React from 'react';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import SideMenuAccordion from './SideMenuAccordion';
import messages from '../../locale/messages';
import Link from '../Link/Link';
import s from './SideMenuItem.css';

export function SideMenuItem({ data, location, intl, isMenuActive, handleMobileMenu }) {
    const { isAccordion, href, icon, label, data: dataValue } = data;
    const { formatMessage } = intl;
    return (
        <>
            {isAccordion ?
                <SideMenuAccordion label={label} isActive={data?.activePaths?.includes(location)} icon={icon} dataValue={dataValue} location={location} handleMobileMenu={handleMobileMenu}/> :
                <Link to={href} className={cx(s.sideMenuItem, (isMenuActive || href == location) && s.sideMenuItemActive)} onClick={handleMobileMenu && handleMobileMenu}>
                    <span className={s.sideMenuItemIconContainer}>
                        {icon}
                    </span>
                    <span className={s.sideMenuItemTextContainer}>
                        {label && formatMessage(messages[label])}
                    </span>
                </Link>}
        </>
    );
}

export default injectIntl(withStyles(s)(SideMenuItem));
